<template>
  <b-overlay :show="loading" class="animated">
    <modal-trash-basket
      v-if="show_modal"
      :entity_type="entity_type"
      :trash="trash"
      @onUpdate="onUpdate"
    />
    <v-server-table
      :columns="table_config.columns"
      :options="table_config.options"
      :theme="theme"
      :ref="ref"
      id="prep-task-server-table"
      class="w-100"
    >
      <span slot="order" slot-scope="{ row }">
        {{ row.order + 1 }}
      </span>
      <span slot="name" slot-scope="{ row }">
        <a :href="`#/prep-tasks/${row.id}`" class="btn-link">{{ row.name }}</a>
      </span>
      <span slot="instruments" slot-scope="{ row }">
        <span v-for="(instrument, index) in row.instruments" :key="index">
          <router-link :to="`/instrument/${instrument.id}`">
            {{ instrument.name }}
          </router-link>
          <template v-if="index !== row.instruments.length - 1">, </template>
        </span>
      </span>
      <span slot="analyses" slot-scope="{ row }">
        {{ formatAnalyses(row) }}
      </span>
      <span slot="actions" slot-scope="{ row }">
        <a
          v-show="checkPermission('edit prep task')"
          class="btn btn-warning px-1 py-0 text-white mr-1"
          :href="`#/prep-tasks/${row.id}/edit`"
        >
          <i class="fa fa-pencil" />
        </a>
        <template v-if="checkPermission('delete prep task')">
          <a
            v-if="isDeleted(row.id)"
            class="btn btn-success px-1 py-0 text-white mr-1"
            @click="restoreFromTrash(row.id)"
          >
            <i class="fa fa-refresh" />
          </a>
          <a
            v-else
            class="btn btn-danger px-1 py-0 text-white mr-1"
            @click="putToTrash(row)"
          >
            <i class="fa fa-trash" />
          </a>
        </template>
      </span>
    </v-server-table>
  </b-overlay>
</template>

<script>
import Vue from "vue";
import BaseServerTable from "@/components/shared/BaseServerTable";
import ExistenceGate from "@/components/shared/ExistenceGate";
import ModalTrashBasket from "@/components/shared/ModalTrashBasket";
import PrepTaskCollection from "@/collections/lab/PrepTaskCollection";
import { mapActions, mapGetters } from "vuex";
import { ServerTable } from "vue-tables-2";
import { AccessControlCheck } from "@/auth/AccessControlCheck";
import { getEntityData, formatAnalyses } from "@/shared/utils";

Vue.use(ServerTable);

export default {
  name: "PrepTaskServerTable",
  extends: BaseServerTable,
  components: {
    ExistenceGate,
    ModalTrashBasket,
    ServerTable,
  },
  props: {
    collection: {
      type: Object,
      default: () => new PrepTaskCollection(),
    },
    show_columns: {
      type: Array,
      default: () => ["order", "name", "instruments", "analyses", "actions"],
    },
    filterable: {
      type: Array,
      default: () => ["searchable"],
    },
    sortable: {
      type: Array,
      default: () => ["order", "name"],
    },
  },
  data() {
    const actions_access =
      this.checkPermission("edit prep task") ||
      this.checkPermission("delete prep task");

    return {
      entity_type: "prepTask",
      prep_process_id: this.$route.params.prep_process_id || null,
      table_config: Object.assign(this.getDefaultTableConfig(actions_access), {
        options: {
          filterable: this.filterable,
          sortable: this.sortable,
        },
      }),
    };
  },
  computed: {
    ...mapGetters({
      trash: "prepTaskTrash",
    }),
    show_modal() {
      return (
        this.checkPermission("delete prep task") &&
        this.show_columns.includes("actions")
      );
    },
  },
  methods: {
    ...mapActions(["PUT_TO_TRASH", "RESTORE_FROM_TRASH"]),
    putToTrash(value) {
      this.PUT_TO_TRASH({ value, name: this.entity_type });
    },
    restoreFromTrash(id) {
      this.RESTORE_FROM_TRASH({ id, name: this.entity_type });
    },
    isDeleted(id) {
      return this.trash.find((item) => item.id === id);
    },
    onUpdate() {
      this.$refs[this.ref].refresh();
    },
    getData({ _reference }, data) {
      return getEntityData({
        entity: _reference,
        ...data,
      });
    },
    checkPermission(permission) {
      return AccessControlCheck.checkPermission(permission);
    },
    formatAnalyses(prep_task) {
      return formatAnalyses(prep_task);
    },
    prepareCollectionFilter(filter) {
      this.prep_process_id &&
        filter.filterEquals("prep_process_id", this.prep_process_id);
      const connections = ["analyses.analyte.sample_type", "instruments"];

      connections.forEach((connection) => {
        filter.connectionAdd(connection);
      });

      return filter;
    },
  },
};
</script>
